export const PRE_PURCHASE_CHECKOUT_PARAM = 'prePurchaseUpsellCheckoutPage';

export const isPrePurchaseUpsellCheckoutPageShown = (query: Record<string, string>) => {
  if (query[PRE_PURCHASE_CHECKOUT_PARAM] === 'true') {
    return true;
  }

  return false;
};
